import { NBSP, RubleSymbol } from '@r1-frontend/ui-react/tokens/symbols';

import { ITariff } from '~/src/entities/formattedTariff';
import { ITariffsResult } from '~/src/features/internet/generateTariffSummaryTableFAQ/utils/getTariffsForTable';

interface ISummaryInfo {
    hasOfferContents: boolean,
    hasAdditionalProducts: boolean,
}
export const transformTariffForSummaryTable = (summaryInfo: ISummaryInfo) => (tariff: ITariff) => {
    const channelsCount = ((tariff.hdCount || 0) + (tariff.sdCount || 0) + (tariff.analog || 0));
    const channels = channelsCount ? channelsCount.toString() : '—';

    const requiredAdditionalProducts = tariff.additionalProducts
        .filter(({ required }) => required === 1)
        .map(({ shopItem }) => shopItem && shopItem.title)
        .join('\n');

    const offerContentTitles = tariff.offerContents.map(({ title }) => title).join('\n');
    const url = tariff.location === '/internet'
        ? `/full-buy?tariffName=${tariff.alias}&monoTariff=true`
        : `${tariff.location}/${tariff.alias}`;

    const price = tariff.priceAction ? `от ${tariff.priceAction}` : tariff.price;
    const result: ITariffsResult = {
        channels,
        url,
        title: tariff.title,
        price: `${price}${NBSP}${RubleSymbol}/мес`,
        speed: `${tariff.speed}${NBSP}Мбит/с`,
        salePackageId: tariff.salePackageId.toString(),
    };

    if (offerContentTitles.length) {
        summaryInfo.hasOfferContents = true;
        result.offerContents = offerContentTitles || '—';
    }

    if (requiredAdditionalProducts.length) {
        summaryInfo.hasAdditionalProducts = true;
        result.additionalProducts = requiredAdditionalProducts || '—';
    }
    return result;
};
